export const DEFAULT_ACTION = "app/UploadInvoice/DEFAULT_ACTION";
export const FORMDATA = "app/UploadInvoice/BLOCKDATA";
export const SETFORMDATA = "app/UploadInvoice/BLOCKDATA/SET/VALUE";
export const SETVALUEFETCH = "app/UploadInvoice/BLOCKDATA/SETVALUEFETCH";